module.exports = __webpack_public_path__ + "img/spouse.ac032f6a.svg";